import { type FC, useContext, useEffect } from 'react';
import { OptimizelyContext } from '@optimizely/react-sdk';

// 🥲, just don't wanna to import from `@/analytics/{project}` cus it's sharable place
import {
  _sendEventToAnalytics as sendEventToAnalytics,
  addEventPropertiesToHeap,
} from '@/utils/analytics/analytics';
import {
  SHARABLE_EVENT_TYPE as EVENT_TYPE,
  SHARABLE_OTHER_REPORT_EVENT as OTHER_REPORT_EVENT,
} from '@/types/analytics';
import { useRouteError } from '@remix-run/react';

export const OptimizelyAnalyticsEvent: FC = () => {
  const { optimizely } = useContext(OptimizelyContext);
  const error = useRouteError();

  useEffect(() => {
    if (error) {
      return;
    }
    optimizely?.onReady().finally(() => {
      const decideAll = optimizely?.decideAll();

      Object.entries(decideAll).forEach(([key, decision]) => {
        if (!decision.enabled) {
          return;
        }

        sendEventToAnalytics(
          EVENT_TYPE.OtherReport,
          `${OTHER_REPORT_EVENT.OPTIMIZELY_DECISION}_${key}`,
          {
            optimizely_enabled: decision.enabled,
            optimizely_reasons: decision.reasons.join(','),
            optimizely_flag_key: decision.flagKey,
            optimizely_rule_key: decision.ruleKey,
            optimizely_variation_key: decision.variationKey,
            optimizely_variables: {
              ...(decision.variables as object),
            },
          },
        );

        const variationKey = `optimizely_ftr_${key}`;
        const variationVariables = Object.fromEntries(
          Object.entries(decision.variables).map(
            ([variableKey, variableValue]) => [
              `${variationKey}_${variableKey}`,
              variableValue || '',
            ],
          ),
        );

        addEventPropertiesToHeap({
          [variationKey]: decision.variationKey || '',
          ...variationVariables,
        });
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
